import now from 'performance-now';
import raf from 'raf';
export var linear = function linear(pos) {
  return pos;
};

var calcPosition = function calcPosition(from, to, t) {
  return from + (to - from) * t;
};

var calcObjOrInt = function calcObjOrInt(from, to, t) {
  var output;

  if (typeof from === 'object') {
    output = Array.isArray(from) ? [] : {};

    for (var key in from) {
      output[key] = calcPosition(from[key], to[key], t);
    }
  } else {
    output = calcPosition(from, to, t);
  }

  return output;
};

export default (function (fn, _ref) {
  var _ref$from = _ref.from,
      from = _ref$from === void 0 ? 0 : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === void 0 ? 1 : _ref$to,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 240 : _ref$duration,
      _ref$timing = _ref.timing,
      timing = _ref$timing === void 0 ? linear : _ref$timing;
  var start = now(),
      time = start + duration;

  var loop = function loop() {
    var p = 1 - (time - now()) / (time - start),
        t = timing(p);

    if (p <= 1) {
      raf(loop);
      fn(calcObjOrInt(from, to, t));
    } else {
      fn(calcObjOrInt(from, to, t > 1 ? 1 : t));
    }
  };

  loop();
});